import { create } from "zustand";
import { ActionsKey } from "../../../common/models/Actions";
import { initialLevageMaterialPageState } from "../core/_model.levage";
import {
  DefaultListResponse,
  DefaultPageState,
} from "../../../common/models/StoreDefaultModel";

export type ActionedLevageHistoryMaterial = {
  data: any;
  action: ActionsKey;
};

type LevageHistoryMaterialDataType = {
  levageMaterialList: any;
  detail: any | null;
  actioned: ActionedLevageHistoryMaterial | null;
  totalItems?: number;
  setDetail: (detail: any | null) => void;
  setLevageHistoryMaterialList: (roles: DefaultListResponse | null) => void;
  setActioned: (act: ActionedLevageHistoryMaterial | null) => void;
  pageState: DefaultPageState;
  setPageState: (state: DefaultPageState) => void;
  resetPageState: () => void;
};

export const useLevageHistoryMaterialStore =
  create<LevageHistoryMaterialDataType>((set) => ({
    levageMaterialList: [],
    detail: null,
    actioned: null,
    totalItems: 0,
    pageState: initialLevageMaterialPageState,
    setDetail: (detail) => set((state) => ({ detail })),
    setLevageHistoryMaterialList: (levageData) =>
      set((state) => ({
        levageMaterialList: levageData?.member,
        totalItems: levageData?.totalItems,
      })),
    setActioned: (act) => set((state) => ({ actioned: act } as any)),
    setPageState: (pageState) => set((state) => ({ pageState })),
    resetPageState: () =>
      set(() => ({
        pageState: {
          page: 1,
          itemsPerPage: 10,
        },
      })),
  }));
